import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { MatomoProvider, createInstance } from 'react-matomo';
import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(
  "c4432cb786ff3d6da66faad73e5edea2Tz0xMTY3OTIsRT0xNzg1MzY5NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=" // Get this from your MUI account dashboard
);

const matomoUrl = 'https://prospectsavant.matomo.cloud/'; // Replace with your URL
const siteId = 1; // Replace with your Site ID

const matomoInstance = createInstance({
  url: matomoUrl,
  siteId: siteId,
});


const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <MatomoProvider value={matomoInstance}>
      <App />
    </MatomoProvider>
  </React.StrictMode>
);
